import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import
import './styles/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Create a root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
